import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../../components/ui/dialog';
import { Button } from '../../../../components/ui/button';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';

export const BulkEditDialog = ({
  open,
  onOpenChange,
  bulkEditTarget,
  selectedImport,
  selectedMain,
  bulkEditInvestorId,
  setBulkEditInvestorId,
  bulkEditTxnType,
  setBulkEditTxnType,
  bulkEditing,
  handleBulkEdit,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="bulk-edit-dialog">
      <DialogHeader>
        <DialogTitle>Bulk Edit {bulkEditTarget === 'staging' ? 'Staging Records' : 'Transactions'}</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 py-2">
        <p className="text-sm text-gray-500">
          Updating {bulkEditTarget === 'staging' ? selectedImport.size : selectedMain.size} record(s). Leave a field blank to keep its current value.
        </p>
        <div>
          <Label className="text-sm font-medium">Investor ID (RP Code)</Label>
          <Input
            data-testid="bulk-edit-investor-id"
            placeholder="e.g., 18-00"
            value={bulkEditInvestorId}
            onChange={e => setBulkEditInvestorId(e.target.value)}
          />
        </div>
        <div>
          <Label className="text-sm font-medium">Transaction Type</Label>
          <select
            data-testid="bulk-edit-txn-type"
            className="w-full border rounded-md px-3 py-2 text-sm"
            value={bulkEditTxnType}
            onChange={e => setBulkEditTxnType(e.target.value)}
          >
            <option value="">— Keep current —</option>
            {['investment','withdrawal','distribution','fee','management_fee','performance_fee',
              'interest_earned','capital_injection','capital_return','deal_purchase','deal_repayment',
              'adjustment','bank_interest','write_off'].map(t => (
              <option key={t} value={t}>{t.replace(/_/g, ' ')}</option>
            ))}
          </select>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          data-testid="bulk-edit-submit"
          onClick={handleBulkEdit}
          disabled={bulkEditing || (!bulkEditInvestorId && !bulkEditTxnType)}
          className="bg-blue-600 hover:bg-blue-700 text-white"
        >
          {bulkEditing ? 'Updating...' : 'Update'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
